import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/check.png'
import _imports_1 from '@/assets/success.png'


const _hoisted_1 = { class: "accordion__form" }
const _hoisted_2 = { class: "accordion__item-left" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "onKeyup"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "accordion__item-right" }
const _hoisted_10 = {
  key: 0,
  src: _imports_1
}
const _hoisted_11 = {
  key: 1,
  class: "accordion__error"
}
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionAnswer = _resolveComponent("AccordionAnswer")!
  const _component_AccordionFooter = _resolveComponent("AccordionFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSortWords, (words, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: words.english,
          class: "accordion__item"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", {
              for: 'inputElement' + index
            }, _toDisplayString(words.russian), 9, _hoisted_3),
            (words?.ruValues != null)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  for: 'inputElement' + index
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(words.ruValues, (ruWords, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, ", " + _toDisplayString(ruWords), 1))
                  }), 128))
                ], 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              id: 'inputElement' + index,
              ref_for: true,
              ref: el => { if (el) _ctx.inputsInfo[index] = el },
              type: "text",
              onKeyup: _withKeys(($event: any) => (_ctx.checkWord(words, index)), ["enter"])
            }, null, 40, _hoisted_5),
            (!_ctx.doneWords.some(wordItem => wordItem.translated == words.english && wordItem.original == words.russian))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.checkWord(words, index))
                }, _hoisted_8, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.doneWords.some(wordItem => wordItem.translated == words.english && wordItem.original == words.russian))
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.errorWords.includes(words.id))
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Неверно! "))
              : _createCommentVNode("", true),
            (_ctx.errorWords.includes(words.id) && !_ctx.isAnswer.includes(words.english))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "accordion__answer",
                  onClick: ($event: any) => (_ctx.addAnswer(words.english))
                }, " ответ ", 8, _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.isAnswer.includes(words.english))
              ? (_openBlock(), _createBlock(_component_AccordionAnswer, {
                  key: 3,
                  onDeleteAnswer: _ctx.deleteAnswer,
                  words: words
                }, null, 8, ["onDeleteAnswer", "words"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_AccordionFooter, { onRotateWords: _ctx.rotateWords }, null, 8, ["onRotateWords"])
  ], 64))
}